import { apiCallStatus } from 'helpers/constants';
import { actionTypes } from './constants';

const initialState = {
    data: null,
    error: null,
    loadingStatus: null
};

const initialActiveDeactivateGatewayState = {
    data: null,
    error: null,
    loadingStatus: null
};

export function lastCommandStatusReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.CLEAR_STORE: {
            return initialState;
        }
        case actionTypes.LAST_COMMAND_ACTIVATE_ACTION_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    data: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    data: null,
                    error: action.error
                };
            }
            break;
        default:
            return state;
    }
}

export function ActivateDeactivateGatewayReducer(state = initialActiveDeactivateGatewayState, action) {
    switch (action.type) {
        case actionTypes.ACTIVATE_DEACTIVATE_GATEWAY_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    data: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    data: null,
                    error: action.error
                };
            }
            break;
        case actionTypes.CLEAR_STORE: {
            return initialActiveDeactivateGatewayState;
        }
        default:
            return state;
    }
}
